var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1A6D73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.584 14.92H10.312L13.456 23.5H11.68L10.96 21.376H7.936L7.216 23.5H5.44L8.584 14.92ZM9.436 16.588L8.344 20.032H10.552L9.436 16.588ZM13.0486 15.1H14.9326L16.5046 20.968H16.5286L18.1126 15.1H19.8406L21.4006 20.968H21.4246L22.9846 15.1H24.9046L22.2526 23.5H20.5606L18.9886 17.968L17.3926 23.5H15.7126L13.0486 15.1ZM25.9126 15.1H27.6526L30.0886 18.904L31.1926 20.836H31.2166L31.1446 18.544V15.1H32.8246V23.5H31.0966L28.6486 19.48L27.5446 17.644H27.5206L27.5926 19.612V23.5H25.9126V15.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.a3f10537287195de757787b99219a8dc.svg";
export { ForwardRef as ReactComponent };